import { Author } from '@services/api/authors'
import React from 'react'
import { AuthorCard } from './author-card'
import classnames from 'classnames'

import styles from './styles.module.scss'
export interface AuthorsListProps {
  authors?: Author[]
  className?: string
}

export const AuthorsList = ({
  authors,
  className
}: AuthorsListProps): JSX.Element => {
  return (
    <div className={classnames(styles.container, className)}>
      {authors.map(({ name, path, avatar, biography, articles }, index) => (
        <React.Fragment key={index}>
          <AuthorCard
            name={name}
            path={path}
            avatar={avatar}
            biography={biography}
            articles={articles}
            className={styles.card}
          />
        </React.Fragment>
      ))}
    </div>
  )
}
